// extracted by mini-css-extract-plugin
export var slide = "CardSlider-module--slide--8ece6";
export var slide__arrow = "CardSlider-module--slide__arrow--d0ee7";
export var slide__image = "CardSlider-module--slide__image--c51b3";
export var slide__next = "CardSlider-module--slide__next--e33d4";
export var slide__prev = "CardSlider-module--slide__prev--e6455";
export var slide__sr = "CardSlider-module--slide__sr--65b56";
export var slider = "CardSlider-module--slider--bc9b9";
export var sliderNav = "CardSlider-module--sliderNav--f49d7";
export var sliderNavLink = "CardSlider-module--sliderNavLink--dd0e9";
export var slides = "CardSlider-module--slides--2a193";